import { useEffect } from "react";
import { useErrorDialog } from "../contexts/ErrorDialogContext";
import { setGlobalErrorDialogHandler } from "../services/policyDownloadService";

/**
 * Hook to set up the global error dialog handler for services
 * Should be called once in a root component that uses download services
 */
export const useErrorDialogSetup = () => {
  const { showErrorDialog } = useErrorDialog();

  useEffect(() => {
    // Set the global error dialog handler when component mounts
    setGlobalErrorDialogHandler(showErrorDialog);

    // Clean up when component unmounts
    return () => {
      setGlobalErrorDialogHandler(null);
    };
  }, [showErrorDialog]);
};
